// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function useCategoryDisplayPriority(category) {
  var match = RouterProvider$Showside.useRouter(undefined);
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var categoryDisplayPriority = Belt_Option.map(category, function (c) {
    return c.displayPriority;
  });
  var indexDisplayPriority = Belt_Option.map(match$1.config.settings.indexNode, function (c) {
    return c.displayPriority;
  });
  if (match.isForcingPLP) {
    return /* ProductsFirst */1;
  } else if (categoryDisplayPriority !== undefined) {
    return categoryDisplayPriority;
  } else if (indexDisplayPriority !== undefined) {
    return indexDisplayPriority;
  } else {
    return /* ChildrenFirst */0;
  }
}
export { useCategoryDisplayPriority };
/* RouterProvider-Showside Not a pure module */